import React from "react";
import styles from "./styles";
import { withStyles, Divider, Grid, withTheme } from "@material-ui/core";
import { postData } from "../../../../../../api/componentAPIs";
import { withSnackbar } from "notistack";
import { compose } from "recompose";
import Events from "../../../../../../utilities/EventEmitter";
import drawConstant from "../../../common/DrawTools/DrawConstant";
import { withAppConfig } from "../../../../../../appConfigContext";
import ActionButton from "./ActionButton";
import Fields from "./Fields";
import constant from "../Constant";
import { getDeserializedRouteNameConfig } from "../../../../../../utilities/appHelper";
class OnBoardTerminalForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
      errorInfo: {},
      inputValue: null,
      updateInProgress: false,
      terminalInfo: this.getDefaultTerminalInfo(),
      divisionList:this.getList("divisionName"),
      regionList:this.getList("regionName")
    };
    this.timer = null;
    this.terminalCodeConfig = this.props.configJSON?.terminalCodeFormat ? getDeserializedRouteNameConfig(this.props.configJSON?.terminalCodeFormat) : null;
  }
  componentDidMount() {
    const { ROUTE_MAPPING_EVENTS } = drawConstant;
    Events.on(ROUTE_MAPPING_EVENTS.DRAWING_UPDATED, this.handleDrawingUpdate);
    Events.on(ROUTE_MAPPING_EVENTS.DRAWING_DELETED, this.handleDrawingDelete);   
  }
  componentWillUnmount() {
    const { ROUTE_MAPPING_EVENTS } = drawConstant;
    Events.off(ROUTE_MAPPING_EVENTS.DRAWING_UPDATED, this.handleDrawingUpdate);
    Events.off(ROUTE_MAPPING_EVENTS.DRAWING_DELETED, this.handleDrawingDelete);
    clearTimeout(this.timer);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.terminalPosition &&
      !Object.is(this.props.terminalPosition, prevProps.terminalPosition) &&
      this.props.terminalPosition?.latitude !==
        this.state.terminalInfo?.latitude &&
      this.props.terminalPosition?.longitude !==
        this.state.terminalInfo?.longitude
    ) {
      //if position of marker changes in a map this will update it in the geocoder
      this.setState({
        inputValue: `${this.props.terminalPosition?.latitude},${this.props.terminalPosition?.longitude}`,
      });
    }
  }

  getList = (fieldName) => {
      //create a option for given field Name
      return [
        ...new Set(this.props.terminalList.map((terminal) => terminal[fieldName])),
      ].map((option) => {
        return {
          label: option,
          value: option,
        };
      });
  };


  getDefaultTerminalInfo() {
    const { terminalInfo } = this.props;
    if (terminalInfo) {
      this.setState({
        inputValue: `${terminalInfo.latitude},${terminalInfo.longitude}`,
      });
      if (this.props.terminalInfo.geoFence) {
        this.selectGeoFenceOnMap(terminalInfo?.terminalId);
      }
    }
    return {
      terminalCode: terminalInfo?.terminalCode || "",
      terminalName: terminalInfo?.terminalName || "",
      longitude: terminalInfo?.longitude || "",
      latitude: terminalInfo?.latitude || "",
      utcToLocalOffset: terminalInfo?.utcToLocalOffset || "",
      region: terminalInfo?.regionName || "",
      division: terminalInfo?.divisionName || "",
      city: terminalInfo?.city || "",
      state: terminalInfo?.state || "",
      zip: terminalInfo?.zip || "",
      isEnabled: terminalInfo ? terminalInfo.isEnabled : true,
      geoFence: terminalInfo?.geoFence || null,
      address: terminalInfo?.address || "",
      sourceTerminalCode:
        this.props.configJSON.terminalOnboarding?.sourceTerminalCode || "",
      country: terminalInfo?.country || "",
      terminalId: terminalInfo?.terminalId || "new",
    };
  }
  selectGeoFenceOnMap = (terminalId) => {
    //need some delay to select drawing so added this code
    // it will take some time to load and draw already exist geofencing after that only we can create.
    //we can remove this settime out if we find better solution
    this.timer = setTimeout(() => {
      Events.emit(
        drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_SELECTED_ON_SIDE_PANEL,
        [terminalId],
        true
      );
    }, 0);
  };

  handleDrawingUpdate = (feature) => {
    this.setState({
      terminalInfo: {
        ...this.state.terminalInfo,
        ["geoFence"]: JSON.stringify(feature.geometry.coordinates[0]),
      },
    });
    if (this.props.terminalInfo?.terminalId !== feature.id) {
      this.props.terminalGeoFencingChange(
        JSON.stringify(feature.geometry.coordinates[0])
      );
    }
    this.selectGeoFenceOnMap(this.state.terminalInfo?.terminalId);
  };

  handleDrawingDelete = (feature) => {
    this.setState({
      terminalInfo: {
        ...this.state.terminalInfo,
        ["geoFence"]: null,
      },
    });
    this.props.terminalGeoFencingChange(null);
  };

  // Update terminalInfo based on inputs
  handleChange = (name) => (value) => {
    if (['division', 'region', 'utcToLocalOffset'].includes(name)) {
        value = value?.value || null;
    }
    if (name === "terminalCode") {
      value = value?.toUpperCase();
    }

    this.setState((state) => ({
      terminalInfo: {
        ...state.terminalInfo,
        [name]: value,
      },
      errorInfo: {
        ...state.errorInfo,
        [name]: this.getFieldError(name, value),
      },
      errorMessage: null,
    }));
  };

  isValidLatitude = (lat) => {
    if (lat) {
      return isFinite(lat) && Math.abs(lat) <= 90 ? null : "* Invalid value";
    }
    return "* Required";
  };

  isValidLongitude = (lng) => {
    if (lng) {
      return isFinite(lng) && Math.abs(lng) <= 180 ? null : "* Invalid value";
    }
    return "* Required";
  };

  validateZipCode = (value) => {
    return value?.length < constant.MIN_ZIP
      ? `Min. of ${constant.MIN_ZIP} characters`
      : null;
  };

  // Checks for errors for each field
  getFieldError = (field, value) => {
    switch (field) {
      case "terminalCode":
        return this.isValidTerminalCode(value);
      case "terminalName":
        return value?.trim() ? null : "* Required";
      case "division":
        return value?.trim() ? null : "* Required";
      case "region":
        return value?.trim() ? null : "* Required";
      case "address":
        return value?.trim() ? null : "* Required";
      case "zip":
        return value ? this.validateZipCode(value) : "* Required";
      case "city":
        return value?.trim() ? null : "* Required";
      case "country":
        return value?.trim() ? null : "* Required";
      case "state":
        return value?.trim() ? null : "* Required";
      case "latitude":
        return this.isValidLatitude(value);
      case "longitude":
        return this.isValidLongitude(value);
      case "utcToLocalOffset":
        return value ? null : "* Required";
      default:
        return null;
    }
  };

  isValidTerminalCode = (value) => {
    if (!value?.trim()) {
      return '* Required';
    }
    return this.terminalCodeConfig?.format.test(value) ? null : '* Invalid Code';
  };

  getLocationDetails = ({longitude, latitude, zip, address, location }) => {
    if (longitude && latitude && address) {
      if (
        latitude !== this.state.terminalInfo?.latitude &&
        longitude !== this.state.terminalInfo?.longitude
      ) {
        this.setState({
          terminalInfo: {
            ...this.state.terminalInfo,
            latitude,
            longitude,
            zip,
            city: location.City,
            country: location.Country,
            state: location.State,
            address,
          },
          errorInfo: {
            ...this.state.errorInfo,
            latitude: this.getFieldError("latitude", latitude),
            longitude: this.getFieldError("longitude", longitude),
            zip: this.getFieldError("zip", zip),
            city: this.getFieldError("city", location.City),
            country: this.getFieldError("country", location.Country),
            state: this.getFieldError("state", location.State),
          },
        });
        this.handleChange("address")(address);
      }
      if (this.state.terminalInfo?.address !== address) {
        this.props.terminalPositionChange({
          latitude,
          longitude,
        });
      }
    } else {
      if (this.props.terminalInfo) {
        this.setState({
          inputValue: `${this.props.terminalInfo.latitude},${this.props.terminalInfo.longitude}`,
        });
      }
      this.props.terminalPositionChange(null);
    }
  };

  // Set Error messages for each field
  getErrorInfo = () => {
    let errorInfo = {};
    Object.keys(this.state.terminalInfo).forEach((fieldName) => {
      errorInfo[fieldName] = this.getFieldError(
        fieldName,
        this.state.terminalInfo[fieldName]
      );
    });
    this.setState({
      errorInfo,
    });
    return errorInfo;
  };

  updateTerminalInfo = () => {
    const errorInfo = this.getErrorInfo();
    const errorData = Object.values(errorInfo).filter((value) => value).length;
    if (!errorData) {
      const data = this.state.terminalInfo;
      delete data["terminalId"];
      this.setState({ updateInProgress: true });
      postData("SaveTerminal", data).then(
        (response) => {
          if (response && response.status >= 200 && response.status < 400) {
            this.setState({ updateInProgress: false });
            this.props.getTerminalData();
            this.props.onClose();
            this.props.enqueueSnackbar(
              `Terminal ${
                this.props.terminalInfo ? "updated" : "onboard"
              } successfully`,
              {
                variant: "success",
              }
            );
            return;
          }
          this.handleError(response.status);
        },
        () => {
          this.handleError();
        }
      );
    }
  };

  handleError = (statusCode) => {
    this.setState({ updateInProgress: false });
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(
      `Error while ${this.props.terminalInfo ? "updating" : "onboarding"} terminal ${this.state.terminalInfo.terminalName}`,
      { variant: "error" }
    );
  };

  toggleAutoZooms = (isEnabled) => {
    this.handleChange("isEnabled")(!isEnabled);
  };

  getAddress = () => {
    if (this.props.terminalInfo) {
      this.setState({
        inputValue: `${this.props.terminalInfo.latitude},${this.props.terminalInfo.longitude}`,
      });
      return `${this.props.terminalInfo.latitude},${this.props.terminalInfo.longitude}`;
    }
    return "";
  };

  render() {
    const { classes, theme } = this.props;
    const {
      terminalInfo,
      errorInfo,
      inputValue,
      updateInProgress,
      errorMessage,
      divisionList, 
      regionList
    } = this.state;

    const buttonText = this.props.terminalInfo
      ? "Update Terminal"
      : "Create Terminal";
    return (
      <div className={`${classes.container} OnBoardTerminalForm`}>
        <div>
          <Grid item xs={12} className={classes.head}>
            {this.props.terminalInfo
              ? "Update Terminal Details"
              : "Add Terminal Details"}
          </Grid>
          <Divider className={classes.divider} />
        </div>
        <div className={`${classes.content} customScroll`}>
          <Fields
            terminalInfo={terminalInfo}
            errorInfo={errorInfo}
            inputValue={inputValue}
            classes={classes}
            theme={theme}
            toggleAutoZooms={this.toggleAutoZooms}
            handleChange={this.handleChange}
            propsTerminalInfo={this.props.terminalInfo}
            getLocationDetails={this.getLocationDetails}
            getAddress={this.getAddress}
            errorMessage={errorMessage}
            divisionList={divisionList}
            regionList={regionList}
            terminalCodeConfig={this.terminalCodeConfig}
          />
          <ActionButton
            classes={classes}
            onClose={this.props.onClose}
            updateTerminalInfo={this.updateTerminalInfo}
            updateInProgress={updateInProgress}
            buttonText={buttonText}
            disabled={Boolean(Object.values(errorInfo).filter((value) => value).length)}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withTheme(),
  withSnackbar,
  withAppConfig
)(OnBoardTerminalForm);
